/* eslint-disable no-unused-vars */
/* eslint-disable react/display-name */
/* eslint-disable max-len */
/* eslint-disable indent */
import React, { useEffect, useState, useRef, forwardRef } from "react";
import "./style.scss";
import { message, Spin, Button } from "antd";
import Heading from "../../components/Heading";
import constant from "./printBookingConstant";
import { useReactToPrint } from "react-to-print";
import print_icon from "../../assests/images/master/print.svg";
import API from "../../api";
import Barcode from "react-barcode";
import urls from "../../api/urls";
import { useParams } from "react-router-dom";
import {
  capitaliseWithHyphen,
  dateFormat_dmy,
  calculateChargeableWeight,
} from "../../utils";
const {
  GET_SINGEL_DOCUMENT_DETAILS_AWB,
  GET_MULTI_DOCUMENT_DETAILS,
  GET_DOCUMENT_DETAILS_BY_AWB_CLIENT,
} = urls;
const { CONDITIONS, CONDITIONS_1 } = constant;
import moment from "moment";
const PrintBooking = forwardRef(
  (
    {
      id,
      idList,
      callPrint,
      currentDateRange,
      loading,
      setLoading,
      transformData,
      clientBooking = false,
    },
    ref
  ) => {
    const componentRef = useRef();
    const [documentDetails, setDocumentDetails] = useState([]);
    // const [loading, setLoading] = useState(false);
    const currentDateTime = moment().format("DD-MM-YYYY HH:mm");
    useEffect(() => {
      if (idList?.length > 0) {
        if (clientBooking) {
          getMultiDataByEngine();
        } else {
          getMultiData();
        }
      } else if (id) {
        if (clientBooking) {
          getDetailsBookingEngine();
        } else {
          getDetails();
        }
      }
    }, [id, idList]);

    const clientLoginId = JSON.parse(localStorage.getItem("userinfo")) || null;

    const getDetailsBookingEngine = async () => {
      setLoading(true);

      let url = `${GET_DOCUMENT_DETAILS_BY_AWB_CLIENT}?bookingType=${"credit"}`;

      if (clientLoginId) {
        url += `&companyId=${clientLoginId?.companyId}`;
      }

      if (id) {
        url += `&documentNos=${+id}`;
      }

      let response = await API.Api(url).getWithAllHeaders();
      if (response?.status) {
        setLoading(false);

        let originalArray = response?.response?.data?.data?.items;
        let temp = transformData(originalArray);
        setDocumentDetails(temp || [{}]);
        // setDocumentDetails([response?.response?.data || {}]);
        setTimeout(() => {
          callPrint();
        }, 1000);
      } else {
        setLoading(false);
        message.error(
          response?.response?.data?.message || "Internal server error."
        );
      }
    };

    const getDetails = async () => {
      setLoading(true);
      let url = `${GET_SINGEL_DOCUMENT_DETAILS_AWB + +id}`;

      let response = await API.Api(url).getWithAllHeaders();
      if (response?.status) {
        setLoading(false);
        setDocumentDetails([response?.response?.data || {}]);
        setTimeout(() => {
          callPrint();
        }, 1000);
      } else {
        setLoading(false);
        message.error(
          response?.response?.data?.message || "Internal server error."
        );
      }
    };

    const getMultiData = async () => {
      setLoading(true);
      let url = `${GET_MULTI_DOCUMENT_DETAILS}?fromDate=${moment(
        currentDateRange.startDate,
        "DD/MM/YYYY"
      ).format("DD-MM-YYYY")}&toDate=${moment(
        currentDateRange.endDate,
        "DD/MM/YYYY"
      ).format("DD-MM-YYYY")}`;

      let response = await API.Api(url).postIdHeader({ awbNumbers: idList });
      if (response?.status) {
        setLoading(false);
        setDocumentDetails(response?.response?.data || []);
        setTimeout(() => {
          callPrint();
        }, 1000);
      } else {
        setLoading(false);
        message.error(
          response?.response?.data?.message || "Internal server error."
        );
      }
    };

    const getMultiDataByEngine = async () => {
      setLoading(true);

      let url = `${GET_DOCUMENT_DETAILS_BY_AWB_CLIENT}?bookingType=${"credit"}`;

      if (clientLoginId) {
        url += `&companyId=${clientLoginId?.companyId}`;
      }

      if (id) {
        url += `&documentNos=${idList?.join(",")}`;
      }

      let response = await API.Api(url).getWithAllHeaders();
      if (response?.status) {
        setLoading(false);

        let originalArray = response?.response?.data?.data?.items;
        let temp = transformData(originalArray);
        setDocumentDetails(temp || [{}]);
        // setDocumentDetails([response?.response?.data || {}]);
        setTimeout(() => {
          callPrint();
        }, 1000);
      } else {
        setLoading(false);
        message.error(
          response?.response?.data?.message || "Internal server error."
        );
      }
    };

    const printHandle = useReactToPrint({
      content: () => componentRef.current,
      onBeforeGetContent: () => {
        setLoading(false);
      },
      onAfterPrint: () => {
        setLoading(false);
      },
      onPrintError: () => {
        setLoading(false);
        console.error("An error occurred while printing.");
      },
    });

    return (
      <div style={{ padding: "10px 90px" }}>
        <Heading
          title="Print Booking"
          extraContent={
            <Button onClick={printHandle}>
              <img src={print_icon} /> <b>PRINT</b>
            </Button>
          }
        />
        <div className="mt-1">
          <Spin spinning={loading}>
            <div
              className="print-booking master-main-container print-container"
              ref={ref}
            >
              {documentDetails?.map((item, i) => (
                <div key={i} className="page-break">
                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <h2
                      style={{
                        fontSize: "12px",
                        textAlign: "center",
                        color: "#000000",
                        float: "left",
                        margin: "0 0 0 80px",
                      }}
                    >
                      COURIER CONSIGNMENT NOTE ISSUED BY COMPANY
                    </h2>
                    <h5>
                      Date:{" "}
                      {moment(
                        item?.shipmentDetails?.bookingCompleteTime
                      ).format("DD-MM-YYYY HH:mm")}
                    </h5>
                  </div>

                  <table
                    width="100%;"
                    border="0"
                    cellSpacing="0"
                    cellPadding="0"
                  >
                    <tbody>
                      <tr>
                        <td
                          width="50%"
                          style={{ padding: "0px", border: "none" }}
                        >
                          <table
                            border="0"
                            cellPadding="3"
                            style={{
                              borderCollapse: "collapse",
                              width: "100%",
                            }}
                          >
                            <tr>
                              <td
                                colSpan="2"
                                width="100%"
                                style={{
                                  borderBottom: "none",
                                  textAlign: "center",
                                  padding: "5px",
                                }}
                                align="center"
                              >
                                <img
                                  src="https://cdn.sevasetu.in/Downloads/New_Company_Logo.png"
                                  alt="Logo"
                                  title="Logo"
                                  style={{ height: "50px" }}
                                />
                              </td>
                            </tr>
                            <tr>
                              <td
                                colSpan="2"
                                width="100%"
                                valign="top"
                                align="top"
                                className="no-border-top"
                              >
                                <div style={{ minHeight: "40px" }}>
                                  <span style={{ fontSize: "10px" }}>
                                    <b>
                                      {" "}
                                      ADDRESS:{" "}
                                      {item?.shipmentDetails?.branchAdress ||
                                        "N/A"}
                                    </b>
                                  </span>
                                </div>
                              </td>
                            </tr>

                            <tr>
                              <td
                                colSpan="2"
                                width="100%"
                                style={{
                                  minHeight: "55px",
                                  paddingLeft: "3px",
                                  paddingTop: "3px",
                                }}
                              >
                                <span
                                  style={{
                                    width: "20px",
                                    float: "left",
                                    WebkitWritingMode: "vertical-lr",
                                    writingMode: "vertical-lr",
                                    fontSize: "12px",
                                    backgroundColor: "#c7cbd7",
                                    textAlign: "center",
                                    margin: "-3px 10px -3px -3px",
                                    height: "80px",
                                    borderRight: "1px solid #332f5f",
                                  }}
                                >
                                  CONSIGNOR
                                </span>
                                <span
                                  style={{
                                    float: "left",
                                    textAlign: "left",
                                    width: "90%",
                                    fontSize: "11px",
                                  }}
                                >
                                  {item?.addressDetails?.senderName || ""},{" "}
                                  {`${
                                    item?.addressDetails?.senderAddressLine1 ||
                                    ""
                                  } ${
                                    item?.addressDetails?.senderAddressLine2 ||
                                    ""
                                  }, ${
                                    item?.addressDetails?.senderCity || ""
                                  }, ${
                                    item?.addressDetails?.senderPincode || ""
                                  }`}
                                </span>
                              </td>
                            </tr>
                            <tr>
                              <td
                                colSpan="2"
                                width="100%"
                                style={{
                                  minHeight: "55px",
                                  paddingLeft: "3px",
                                  paddingTop: "3px",
                                }}
                              >
                                <span
                                  style={{
                                    width: "20px",
                                    float: "left",
                                    WebkitWritingMode: "vertical-lr",
                                    writingMode: "vertical-lr",
                                    fontSize: "12px",
                                    backgroundColor: "#c7cbd7",
                                    textAlign: "center",
                                    margin: "-3px 10px -3px -3px",
                                    height: "80px",
                                    borderRight: "1px solid #332f5f",
                                  }}
                                >
                                  CONSIGNEE
                                </span>
                                <span
                                  style={{
                                    float: "left",
                                    textAlign: "left",
                                    width: "90%",
                                    fontSize: "11px",
                                  }}
                                >
                                  {item?.addressDetails?.receiverName || ""},{" "}
                                  {`${
                                    item?.addressDetails
                                      ?.receiverAddressLine1 || ""
                                  } ${
                                    item?.addressDetails
                                      ?.receiverAddressLine2 || ""
                                  }, ${
                                    item?.addressDetails?.receiverCity || ""
                                  }, ${
                                    item?.addressDetails?.receiverPincode || ""
                                  }`}
                                </span>
                              </td>
                            </tr>
                            <tr>
                              <td
                                colSpan="2"
                                width="100%"
                                style={{
                                  fontSize: "9px",
                                  textAlign: "center",
                                  padding: "1px",
                                }}
                              >
                                <strong>SERVICE ACCOUNTING CODE: </strong>
                                <span>996812</span>
                                <strong> DESCRIPTION OF SERVICE: </strong>
                                <span>COURIER SERVICE</span>
                              </td>
                            </tr>
                            <tr>
                              <td width="60%" className="p1px">
                                <strong>WEIGHT</strong>
                              </td>
                              <td width="40%" className="p1px">
                                <span>
                                  <span>
                                    <span>
                                      {(() => {
                                        const {
                                          shipmentDetails,
                                          childShipmentDetails = [],
                                        } = item || {};
                                        const {
                                          volumetricWeight = 0,
                                          weight = 0,
                                          type,
                                        } = shipmentDetails || {};

                                        const parentWeight = Math.max(
                                          weight || 0,
                                          volumetricWeight || 0
                                        );

                                        // Sum the max of weight or volumetricWeight for each child shipment
                                        const childWeight =
                                          childShipmentDetails?.reduce(
                                            (sum, child) =>
                                              sum +
                                              Math.max(
                                                child?.weight || 0,
                                                child?.volumetricWeight || 0
                                              ),
                                            0
                                          ) || 0;

                                        // Total weight including parent shipment
                                        const totalWeight =
                                          parentWeight + childWeight || 0;

                                        const totalVolumetricWeight =
                                          volumetricWeight; // Assuming parent volumetric weight is considered separately

                                        if (type?.toLowerCase() === "dox") {
                                          const volumetricWeightInGrams =
                                            totalVolumetricWeight * 1000;
                                          const weightInGrams = weight;
                                          return `${Math.max(
                                            volumetricWeightInGrams,
                                            weightInGrams
                                          )} Gm`;
                                        } else {
                                          return `${
                                            Math.max(
                                              totalVolumetricWeight,
                                              totalWeight
                                            )?.toFixed(2) || 0
                                          } Kg`;
                                        }
                                      })()}
                                    </span>
                                  </span>
                                </span>
                              </td>
                            </tr>
                            <tr>
                              <td width="60%" className="p1px">
                                <strong>VOLUMETRIC CHARGE</strong>
                              </td>
                              <td width="40%" className="p1px">
                                <span>A/C</span>
                              </td>
                            </tr>
                            <tr>
                              <td width="60%" className="p1px">
                                <strong>FREIGHT CHARGE</strong>
                              </td>
                              <td width="40%" className="p1px">
                                <span>A/C</span>
                              </td>
                            </tr>
                            <tr>
                              <td width="60%" className="p1px">
                                <strong>FREIGHT ON VALUE</strong>
                              </td>
                              <td width="40%" className="p1px">
                                <span>0</span>
                              </td>
                            </tr>
                            <tr>
                              <td width="60%" className="p1px">
                                <strong>TAXABLE VALUE</strong>
                              </td>
                              <td width="40%" className="p1px">
                                <span>0</span>
                              </td>
                            </tr>
                            <tr>
                              <td width="60%" className="p1px">
                                <strong>SGST@9%</strong>
                              </td>
                              <td width="40%" className="p1px">
                                <span>A/C</span>
                              </td>
                            </tr>
                            <tr>
                              <td width="60%" className="p1px">
                                <strong>CGST@9%</strong>
                              </td>
                              <td width="40%" className="p1px">
                                <span>A/C</span>
                              </td>
                            </tr>
                            <tr>
                              <td width="60%" className="p1px">
                                <strong>IGST@18%</strong>
                              </td>
                              <td width="40%" className="p1px">
                                <span>A/C</span>
                              </td>
                            </tr>
                            <tr>
                              <td width="60%" className="p1px">
                                <strong>CESS@ %1 </strong>
                              </td>
                              <td width="40%" className="p1px">
                                <span>A/C</span>
                              </td>
                            </tr>
                            <tr>
                              <td width="60%" className="p1px">
                                <strong>TOTAL CHARGE</strong>
                              </td>
                              <td width="40%" className="p1px">
                                <span>A/C</span>
                              </td>
                            </tr>
                          </table>
                        </td>

                        <td
                          width="50%"
                          colSpan="1"
                          style={{ padding: "0px", border: "none" }}
                          valign="left"
                        >
                          <table
                            border="0"
                            cellPadding="3"
                            style={{
                              borderCollapse: "collapse",
                              width: "100%",
                            }}
                          >
                            {/* <tr>
                        <td
                          width="33.33%"
                          style={{
                            textAlign: "center",
                            borderLeft: "none",
                            wordBreak: "break-word",
                          }}
                        >
                          <b>DATE</b> <br />
                          {moment(
                            item?.shipmentDetails
                              ?.bookingCompleteTime
                          ).format("YYYY-MM-DD HH:mm")}
                        </td>
                        <td
                          width="33.33%"
                          style={{
                            textAlign: "center",
                            wordBreak: "break-word",
                          }}
                        >
                          <b>ORIGIN</b> <br />
                          {item?.cpName}
                        </td>
                        <td
                          width="33.33%"
                          style={{
                            textAlign: "center",
                            wordBreak: "break-word",
                          }}
                        >
                          <b>DESTINATION</b> <br />
                          {item?.destinationCpName || "N/A"}
                        </td>
                      </tr> */}
                            <tr>
                              <td
                                width="60%"
                                align="center"
                                style={{
                                  borderLeft: "none",
                                  textAlign: "center",
                                  fontSize: "11px",
                                }}
                                colSpan="2"
                              >
                                <span style={{ paddingBottom: "2px" }}>
                                  <b>PRODUCT:</b>
                                </span>
                                <span>
                                  <b>DOX</b>
                                  <span
                                    style={{
                                      marginTop: "10px",
                                      marginLeft: "4px",
                                      marginRight: "5px",
                                    }}
                                  >
                                    <img
                                      height="12px"
                                      width="12px"
                                      src={
                                        item?.shipmentDetails?.type?.toLowerCase() ===
                                        "dox"
                                          ? "https://cdn.shreemaruticourier.com/images/checkbox-button-check-box.png"
                                          : "https://cdn.shreemaruticourier.com/images/checkbox-button-no-check-box.png"
                                      }
                                      alt={
                                        item?.shipmentDetails?.type?.toLowerCase() ===
                                        "dox"
                                          ? "DOX"
                                          : "NON DOX"
                                      }
                                    />
                                  </span>
                                </span>
                                <span>
                                  <b>NON DOX</b>
                                  <span
                                    style={{
                                      marginTop: "10px",
                                      marginLeft: "4px",
                                      marginRight: "5px",
                                    }}
                                  >
                                    <img
                                      height="12px"
                                      width="12px"
                                      src={
                                        item?.shipmentDetails?.type?.toLowerCase() ===
                                        "non-dox"
                                          ? "https://cdn.shreemaruticourier.com/images/checkbox-button-check-box.png"
                                          : "https://cdn.shreemaruticourier.com/images/checkbox-button-no-check-box.png"
                                      }
                                      alt={
                                        item?.shipmentDetails?.type?.toLowerCase() ===
                                        "non-dox"
                                          ? "DOX"
                                          : "NON DOX"
                                      }
                                    />
                                  </span>
                                </span>
                                <br />
                                <br />
                                <span>
                                  <b>FASTTRACK</b>
                                  <img
                                    style={{
                                      marginLeft: "4px",
                                      marginRight: "5px",
                                    }}
                                    height="12px"
                                    width="12px"
                                    src={
                                      item?.serviceDetails?.service?.toLowerCase() ===
                                      "fast track"
                                        ? "https://cdn.shreemaruticourier.com/images/checkbox-button-check-box.png"
                                        : "https://cdn.shreemaruticourier.com/images/checkbox-button-no-check-box.png"
                                    }
                                    alt="FASTTRACK"
                                  />
                                </span>
                                {item?.serviceDetails?.service?.toLowerCase() ===
                                  "vayuquick_pro" && (
                                  <span>
                                    <b>VAYU QUICK PRO</b>
                                    <img
                                      style={{
                                        marginLeft: "4px",
                                        marginRight: "5px",
                                      }}
                                      height="12px"
                                      width="12px"
                                      src={
                                        item?.serviceDetails?.service?.toLowerCase() ===
                                        "vayuquick_pro"
                                          ? "https://cdn.shreemaruticourier.com/images/checkbox-button-check-box.png"
                                          : "https://cdn.shreemaruticourier.com/images/checkbox-button-no-check-box.png"
                                      }
                                      alt="vayu quick pro"
                                    />
                                  </span>
                                )}

                                {item?.serviceDetails?.service?.toLowerCase() ===
                                  "vayuquick" && (
                                  <span>
                                    <b>VAYU QUICK</b>
                                    <img
                                      style={{
                                        marginLeft: "4px",
                                        marginRight: "5px",
                                      }}
                                      height="12px"
                                      width="12px"
                                      src={
                                        item?.serviceDetails?.service?.toLowerCase() ===
                                        "vayuquick"
                                          ? "https://cdn.shreemaruticourier.com/images/checkbox-button-check-box.png"
                                          : "https://cdn.shreemaruticourier.com/images/checkbox-button-no-check-box.png"
                                      }
                                      alt="vayu quick"
                                    />
                                  </span>
                                )}
                              </td>
                              <td
                                style={{
                                  textAlign: "center",
                                  padding: 0,
                                }}
                              >
                                <b>C.N.No.</b>
                                <br />

                                {item?.awbNumber && (
                                  <Barcode
                                    value={item?.awbNumber}
                                    width={0.9}
                                    height={20}
                                    displayValue={true}
                                    fontSize={12}
                                  />
                                )}
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <strong>Weight:</strong>{" "}
                                {calculateChargeableWeight(
                                  item?.shipmentDetails,
                                  item?.childShipmentDetails
                                )}{" "}
                                {item?.shipmentDetails?.type?.toLowerCase() ===
                                "non-dox"
                                  ? "Kg"
                                  : "Gm"}
                              </td>
                            </tr>
                            <tr>
                              <td
                                colSpan="2"
                                style={{
                                  borderLeft: "none",
                                  fontSize: "11px",
                                }}
                              >
                                <span>
                                  <strong>(L * B * H):</strong>{" "}
                                  {item?.shipmentDetails?.length} *{" "}
                                  {item?.shipmentDetails?.width} *{" "}
                                  {item?.shipmentDetails?.height} ={" "}
                                  {item?.shipmentDetails?.volumetricWeight} Kg
                                </span>{" "}
                              </td>
                              <td>
                                <strong>MODE: </strong>
                                <span>
                                  {capitaliseWithHyphen(
                                    item?.serviceDetails?.travelBy
                                  )}
                                </span>
                              </td>
                            </tr>
                            <tr>
                              <td
                                width="65%"
                                colSpan="2"
                                style={{ borderLeft: "none", fontSize: "11px" }}
                              >
                                <b>CONTENT OF SHIPMENT</b>
                              </td>
                              <td width="35%" style={{ fontSize: "11px" }}>
                                <b>VALUE OF GOODS</b>
                              </td>
                            </tr>
                            <tr>
                              <td
                                colSpan="2"
                                width="65%"
                                style={{
                                  height: "40px",
                                  borderLeft: "none",
                                  fontSize: "11px",
                                }}
                              >
                                {item?.shipmentDetails?.content}
                              </td>
                              <td width="35%" style={{ height: "40px" }}>
                                {item?.shipmentDetails?.value}
                              </td>
                            </tr>
                            <tr>
                              <td
                                width="65%"
                                colSpan="3"
                                style={{ borderLeft: "none", fontSize: "11px" }}
                              >
                                <b>SHIPMENT TYPE: </b>
                                {item?.childShipmentDetails?.length > 0 ? (
                                  <>
                                    Multi-Piece Shipment (Child Count:{" "}
                                    {item.childShipmentDetails.length})
                                  </>
                                ) : (
                                  <>Single-Piece Shipment</>
                                )}
                              </td>
                            </tr>
                            <tr>
                              <td
                                colSpan="3"
                                style={{
                                  paddingBottom: "5px",
                                  borderLeft: "none",
                                }}
                              >
                                <strong style={{ color: "#b3494d" }}>
                                  CONDITIONS OF CARRIAGE:
                                </strong>
                                <br />
                                <span
                                  style={{
                                    fontSize: "6.5px",
                                    float: "left",
                                    width: "100%",
                                  }}
                                >
                                  <span
                                    style={{
                                      fontSize: "6.5px",
                                      marginTop: "3px",
                                      float: "left",
                                      width: "100%",
                                    }}
                                  >
                                    {CONDITIONS?.map((e, i) => (
                                      <span key={i}>
                                        {i + 1}. {e}
                                        <br />
                                      </span>
                                    ))}
                                  </span>
                                </span>
                              </td>
                            </tr>
                            <tr>
                              <td colSpan="2" style={{ borderLeft: "none" }}>
                                <span>
                                  <b>CONSIGNOR SIGNATURE</b>
                                </span>
                                <div style={{ height: "25px" }}></div>
                                <div>
                                  <span style={{ width: "100%" }}>
                                    <strong>Printed on: </strong>
                                    {currentDateTime}
                                  </span>
                                </div>
                              </td>
                              <td>
                                <span>
                                  <b>RECEIVED BY</b>
                                </span>
                                <div style={{ height: "35px" }}></div>
                              </td>
                            </tr>
                            <tr>
                              <td
                                colSpan="3"
                                style={{
                                  borderBottom: "none",
                                  borderLeft: "none",
                                }}
                              >
                                <strong>Branch Office : </strong>

                                <div style={{ minHeight: "25px" }}>
                                  {item?.shipmentDetails?.branchName || "N/A"}
                                  <br />
                                  <span
                                    style={{
                                      fontSize: "11px",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    Channel Partner of SHREE MARUTI INTEGRATED
                                    LOGISTICS LIMITED
                                  </span>{" "}
                                </div>
                              </td>
                            </tr>
                          </table>
                        </td>
                      </tr>
                      <tr>
                        <td colSpan="2" style={{ border: "none" }}>
                          <table
                            border="0"
                            cellPadding="0"
                            style={{
                              borderCollapse: "collapse",
                              width: "100%",
                            }}
                          >
                            <tr>
                              <td style={{ fontSize: "10px" }} colSpan="2">
                                <strong style={{ color: "#b3494d" }}>
                                  GSTIN:{" "}
                                </strong>
                                <span>
                                  {item?.shipmentDetails?.gstNo || "N/A"}
                                </span>
                                <strong style={{ color: "#000000" }}>
                                  &nbsp;&nbsp;|&nbsp;&nbsp;
                                </strong>
                                <strong style={{ color: "#b3494d" }}>
                                  StateCode:{" "}
                                </strong>
                                <span>
                                  {item?.shipmentDetails?.stateCode || "N/A"}
                                </span>
                                <strong style={{ color: "#000000" }}>
                                  &nbsp;&nbsp;|&nbsp;&nbsp;
                                </strong>
                                <strong style={{ color: "#b3494d" }}>
                                  State:{" "}
                                </strong>
                                <span>
                                  {item?.shipmentDetails?.state || "N/A"}
                                </span>
                              </td>
                            </tr>
                          </table>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <table
                    width="98%"
                    style={{ tableLayout: "fixed" }}
                    border="0"
                    cellSpacing="0"
                    cellPadding="-10"
                  >
                    <tbody>
                      <tr>
                        <td
                          align="center"
                          style={{
                            height: "20px",
                            border: "none",
                            color: "#b3494d",
                          }}
                        >
                          <b>CONDITIONS OF CARRIAGE :</b>
                        </td>
                      </tr>
                      <tr>
                        <td style={{ fontSize: "6.5px", border: "none" }}>
                          <ul style={{ paddingLeft: "0", listStyle: "none" }}>
                            {CONDITIONS_1?.map((e, i) => (
                              <span key={i}>
                                {i + 5}. {e}
                                <br />
                              </span>
                            ))}
                          </ul>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <hr className="divider" />
                </div>
              ))}
            </div>
          </Spin>
        </div>
      </div>
    );
  }
);

export default PrintBooking;
